import { connect } from 'react-redux';

import ForgotPasswordConfirmation from './forgot-password-confirmation';

import { resetLogin } from 'state/actions/login';
import { handleAjaxError, showSuccessFlag } from 'state/actions/flags';

export default connect(undefined, {
    resetLoginAction: resetLogin,
    onResendLinkError: handleAjaxError,
    onResendSuccess: showSuccessFlag,
})(ForgotPasswordConfirmation);
